// import React, { Component } from 'react';
// import Cookies from 'universal-cookie';
// import '../CSS/assets-minified/all-demo.css'
// import '../CSS/assets-minified/css/bootstrap.min.css'
// import Header from '../components/dashboardSubComponents/header'
// import SideBar from '../components/dashboardSubComponents/sideBarNav'
// import { Loader } from 'react-overlay-loader';
// import { url,logout } from '../components/helper'
// // import ResponseTable from './responseListSubComponenets/responseTable'
// // import MultiSelectList from './roleManagementSubComponents/mutiSelectList'
// import SelectList from '../components/createQuestionSubComponents/dropdownSelect'
// import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
// import Select from 'react-select';

// class RoleManagement extends Component{

//     constructor(props){
//         super(props)
//         this.state = {
//             section:1,
//             orgEdit:true,
//             branchEdit:true,
//             branchView:false,
//             branchViewEdit:true,
//             userDeatilViewHidden:true,
//             superuser:false,
//             organization_admin:false,
//             editOragizationModalOpen:false,
//             editBranchModalOpen:false,
//             allUsers : [],
//             organizations:[],
//             selectedOrganizations:[],
//             branches:[],
//             branch_opts:[],
//             branchAdminSelectedOrg:null,
//             selectedBranches:[],
//             user_options:[],
//             selectedUser:null,
//             modalLoading:false,
//             loading:false,
//             messageBoxOpen:false,
//             messageTitle:"",
//             messageBody:"",
//             messageType:0

//         }
//         this.HandleUserSelect = this.HandleUserSelect.bind(this)
//         this.HandleOrgRadioClick = this.HandleOrgRadioClick.bind(this)
//         this.HandleOrgEditClick = this.HandleOrgEditClick.bind(this)
//         this.HandleOrganizationSelect = this.HandleOrganizationSelect.bind(this)
//         this.fetchOrgBranches = this.fetchOrgBranches.bind(this)
//         this.CloseBranchEditModal = this.CloseBranchEditModal.bind(this)
//         this.HandleBranchRadioClick = this.HandleBranchRadioClick.bind(this)
//         this.HandleBranchAdminOrgSelect = this.HandleBranchAdminOrgSelect.bind(this)
//         this.HandleBranchSelect = this.HandleBranchSelect.bind(this)
//         this.updateRoles = this.updateRoles.bind(this)
//         this.closeMessageBox = this.closeMessageBox.bind(this)
//     }

//     componentWillMount = () =>{
//         var cookies = new Cookies();
//         var loginStatus = cookies.get('loggedIn')
//         if (loginStatus === undefined) {
//             window.location = '/login'
//         }
//         var temp = cookies.get('superuser')
//         //(typeof temp )
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         this.setState({
//             superuser : cookies.get('superuser'),
//             organization_admin : cookies.get('organization-admin'),
//         })
//         if(cookies.get('branch-admin') === "true" || cookies.get('branch-user') === "true"){

//             window.location = '/dashboard'
//         }

//         var global_ref = this
//         var http = new XMLHttpRequest();
//         http.open("GET",url+"/api/user/role?user_id="+user_id,true)
//         http.setRequestHeader("Authorization", "Bearer " + token);
//         http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
//         http.send()
//         http.onreadystatechange = function(){
//             if(http.readyState === 4 && http.status === 200){
//                 //(http.responseText)
//                 var json = JSON.parse(http.responseText)

//                 if(json.status === 200){
//                     var user_opts=[]
//                     var org_opts = []
//                     json.users.forEach(element =>{
//                         temp = {value:element.user_id, label:element.first_name+" "+element.last_name+" ("+element.username+")", id:element.user_id}
//                         user_opts.push(temp)
//                     })

//                     json.organisations.forEach(element =>{
//                         temp={value:element.org_id, label:element.org_name, id:element.org_id}
//                         org_opts.push(temp)
//                     })
//                     //("************")
//                     //(org_opts)
//                     global_ref.setState({
//                         user_options:user_opts,
//                         allUsers:json.users,
//                         organizations:org_opts
//                     })
//                 }
//             }
//         }
//     }

//     HandleUserSelect = (user) =>{

//         allUsers.forEach(element =>{
//             if(user.id === element.user_id){
//                 if(element.is_super_admin === true){
//                     document.getElementById("super").checked = true
//                     this.setState({branchEdit:true,orgEdit:true})
//                 }
//                 if(element.is_org_admin === true && element.user_orgs.length !== 0){
//                     document.getElementById("org").checked = true
//                     this.setState({orgEdit:false,branchEdit:true})
//                 }
//                 console.log("element ", element)
//                 if(element.is_branch_admin === true && element.user_branches.length !== 0){
//                     document.getElementById("branch").checked = true
//                     this.fetchOrgBranches(element.user_branches[0].org_id)
//                     this.setState({branchEdit:false,orgEdit:true,loading:true})
//                 }
//                 // fix later
//                 if(element.is_branch_user === true && element.user_branches.length !== 0){
//                     document.getElementById("branchView").checked = true
//                     this.fetchOrgBranches(element.user_branches[0].org_id)
//                     this.setState({branchViewEdit:false,orgEdit:false,loading:true})
//                 }
//                 if(element.is_revoked === true){
//                     document.getElementById("revoked").checked = true
//                     this.setState({branchEdit:true,orgEdit:true})
//                 }
//             }
//             this.setState({
//                 selectedUser:user,
//                 userDeatilViewHidden:false, selectedOrganizations:[], branchAdminSelectedOrg:null, selectedBranches:[]
//             })
//         })
//     }
//     fetchOrgBranches = (org_id) =>{
//         //("fetch received "+org_id)
//         var cookies = new Cookies();
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         var dashboar_ref = this;
//         var http = new XMLHttpRequest();
//         http.open('GET', url+'/api/questions/wizard/branch?user_id=' + user_id + '&org_id=' + org_id, true);
//         http.setRequestHeader("Authorization", "Bearer " + token);
//         http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
//         http.send()
//         http.onreadystatechange = function(){
//             if(http.readyState === 4 && http.status === 200){
//                 var json = JSON.parse(http.responseText)
//                 if (json.status === 200) {
//                     //("got branches")
//                     var branches = []
//                     json.branches.forEach(element => {
//                         var temp = {
//                             value: element.branch_id, label: element.branch_name, id: element.branch_id
//                         }
//                         branches.push(temp)
//                         //(branches)
//                     });
//                     dashboar_ref.setState({
//                         branch_opts: branches,
//                         branches:json.branches,
//                         modalLoading:false,
//                         loading:false
//                     })
//                 }
//             }
//         }
//     }

//     CloseOrgEditModal = () =>{
//         this.setState({
//             editOragizationModalOpen:false
//         })
//     }

//     closeMessageBox = () =>{
//         if(this.state.messageType === 1){
//             this.setState({messageBoxOpen:false})
//             window.location = "/role-management/"
//         }
//         else{
//             this.setState({messageBoxOpen:false})
//         }
//     }

//     HandleOrgRadioClick = () =>{
//         //("org handle called")
//         if(this.state.selectedOrganizations.length === 0){
//             var target = this.state.selectedUser
//         var isChecked = document.getElementById("org").checked
//         if(isChecked === true){
//         var targetOrgs = []
//         var tempSelectedopts=[]
//         this.state.allUsers.forEach(element =>{
//             if(element.user_id === target.id){
//                 targetOrgs = element.user_orgs
//             }

//         })
//         targetOrgs.forEach(element =>{
//             tempSelectedopts.push({value:element.org_id,label:element.org_name,id:element.org_id})
//         })
//             this.setState({
//                 editOragizationModalOpen:true, selectedOrganizations:tempSelectedopts
//             })
//         }
//         }
//         else{
//             this.setState({
//                 editOragizationModalOpen:true, selectedOrganizations:tempSelectedopts
//             })
//         }
//     }

//     HandleOrgEditClick = () =>{
//         document.getElementById("org").checked = true
//         if(this.state.selectedOrganizations.length === 0){
//             var target = this.state.selectedUser

//             var targetOrgs = []
//             var tempSelectedopts=[]
//             this.state.allUsers.forEach(element =>{
//                 if(element.user_id === target.id){
//                     targetOrgs = element.user_orgs
//                 }

//             })
//             targetOrgs.forEach(element =>{
//                 tempSelectedopts.push({value:element.org_id,label:element.org_name,id:element.org_id})
//             })
//             this.setState({editOragizationModalOpen:true, selectedOrganizations:tempSelectedopts})
//         }
//         else{
//             this.setState({editOragizationModalOpen:true})
//         }
//     }

//     HandleOrganizationSelect = (orgs) =>{
//         this.setState({
//             selectedOrganizations:orgs
//         })
//     }

//     CloseBranchEditModal = () =>{
//         this.setState({
//             editBranchModalOpen:false
//         })
//     }

//     HandleBranchRadioClick = () =>{
//         document.getElementById("branch").checked=true
//         var targetUser = null
//         var tagetOrg = null
//         var tagetBranches = []
//         this.state.allUsers.forEach(element =>{
//             if(this.state.selectedUser.id === element.user_id){
//                 targetUser = element
//             }
//         })
//         if(targetUser.user_branches.length !== 0){

//             if(this.state.branchAdminSelectedOrg === null){
//                 this.state.organizations.forEach(element =>{
//                     if(element.id === targetUser.user_branches[0].org_id){
//                         tagetOrg = element
//                     }
//                 })
//             }
//             else{
//                 tagetOrg = this.state.branchAdminSelectedOrg
//             }
//          targetUser.user_branches.forEach(outElement =>{
//             this.state.branches.forEach(InElement =>{
//                 if(InElement.branch_id === outElement.branch_id){
//                     tagetBranches.push({value:outElement.branch_id,label:outElement.branch_name, id:outElement.branch_id})
//                 }
//             })
//          })
//             this.setState({
//                 editBranchModalOpen:true,
//                 branchAdminSelectedOrg:tagetOrg,
//                 selectedBranches:tagetBranches
//             })
//         }
//         else{
//             this.setState({
//                 editBranchModalOpen:true,
//             })
//         }
//     }
//     HandleBranchViewRadioClick = () =>{
//         document.getElementById("branchView").checked=true
//         var targetUser = null
//         var tagetOrg = null
//         var tagetBranches = []
//         this.state.allUsers.forEach(element =>{
//             if(this.state.selectedUser.id === element.user_id){
//                 targetUser = element
//             }
//         })
//         if(targetUser.user_branches.length !== 0){

//             if(this.state.branchAdminSelectedOrg === null){
//                 this.state.organizations.forEach(element =>{
//                     if(element.id === targetUser.user_branches[0].org_id){
//                         tagetOrg = element
//                     }
//                 })
//             }
//             else{
//                 tagetOrg = this.state.branchAdminSelectedOrg
//             }
//          targetUser.user_branches.forEach(outElement =>{
//             this.state.branches.forEach(InElement =>{
//                 if(InElement.branch_id === outElement.branch_id){
//                     tagetBranches.push({value:outElement.branch_id,label:outElement.branch_name, id:outElement.branch_id})
//                 }
//             })
//          })
//             this.setState({
//                 editBranchModalOpen:true,
//                 branchAdminSelectedOrg:tagetOrg,
//                 selectedBranches:tagetBranches
//             })
//         }
//         else{
//             this.setState({
//                 editBranchModalOpen:true,
//             })
//         }
//     }

//     HandleBranchAdminOrgSelect = (org) =>{
//         var targetUser = null
//         // var tagetOrg = null
//         var tagetBranches = []
//         this.state.allUsers.forEach(element =>{
//             if(this.state.selectedUser.id === element.user_id){
//                 targetUser = element
//             }
//         })
//         if(targetUser.is_branch_admin === true && targetUser.user_branches[0].org_id === org.id){
//             this.fetchOrgBranches(org.id)
//             //("************")
//             //(this.state.branches)
//             targetUser.user_branches.forEach(element =>{
//                 tagetBranches.push({value:element.branch_id, label:element.branch_name,id:element.branch_id})
//              })
//             //(tagetBranches)
//             this.setState({branchAdminSelectedOrg:org,
//             selectedBranches:tagetBranches,
//             modalLoading:true})
//         }
//         else{
//             this.setState({branchAdminSelectedOrg:org,
//                 branch_opts:[],
//                 branches:[],
//                 selectedBranches:[],
//                 modalLoading:true})
//             this.fetchOrgBranches(org.id)
//         }

//     }

//     HandleBranchSelect = (branch) =>{
//         this.setState({selectedBranches:branch})
//     }

//     updateRoles = () =>{
//         var arg_list = "&u_id="+this.state.selectedUser.id
//         var superUser = false
//         if(this.state.superuser === "true"){
//             superUser = document.getElementById("super").checked
//         }

//         if(this.state.superuser === "true"){
//             var org = document.getElementById("org").checked
//         }
//         var branch = document.getElementById("branch").checked;
//         var branchView = document.getElementById("branchView").checked;
//         var revoked = document.getElementById("revoked").checked

//         if(org === true && this.state.selectedOrganizations.length === 0){
//                 this.setState({
//                     messageTitle:"No Organization Selected",
//                     messageBody:"You have checked Organization Admin Option. Please also select atleast one organization",
//                     messageBoxOpen:true
//                 })
//                 return
//         }

//         if(branch === true && (this.state.branchAdminSelectedOrg === null || this.state.selectedBranches.length === 0)){
//             this.setState({
//                 messageTitle:"No Organization/Branch Selected",
//                 messageBody:"You have checked Branch Admin Option. Please also select atleast one organization and branch",
//                 messageBoxOpen:true
//             })
//             return
//         }
//         if(org === true){
//             var orgs = ""
//             this.state.selectedOrganizations.forEach(element =>{

//                 orgs = orgs+","+element.id
//             })
//             orgs = orgs.substring(1)
//             arg_list = arg_list + "&is_org=True&orgs="+orgs
//         }

//         if(branch === true){
//             var branches = ""
//             this.state.selectedBranches.forEach(element =>{
//                 branches = branches+","+element.id
//             })
//             arg_list = arg_list+"&is_branch=True"+"&branches="+branches.substring(1)
//         }
//         if(branchView)
//         {
//             var viewBranches = ""
//             this.state.selectedBranches.forEach(element =>{
//                 viewBranches = viewBranches+","+element.id
//             })
//             arg_list = arg_list+"&is_branch_user=True"+"&branches="+viewBranches.substring(1)
//         }        //(arg_list)
//         if(superUser === true){
//             arg_list = arg_list+"&is_super=True"
//         }

//         if(revoked === true){
//             arg_list = arg_list+"&is_revoke=True"
//         }
//         const cookies = new Cookies();
//         var http = new XMLHttpRequest();
//         var dashboar_ref = this
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         http.open('POST', url+'/api/user/role?user_id='+user_id, true);
//         http.setRequestHeader("Authorization", "Bearer " + token);
//         http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
//         http.send(arg_list)
//         http.onreadystatechange = function(){
//             if(http.readyState === 4 && http.status === 200){
//                 //(http.responseText)
//                 var json = JSON.parse(http.responseText)
//                 if(json.status === 200){
//                     dashboar_ref.setState({
//                         messageTitle:"Role Updated",
//                         messageBody:"The role for "+dashboar_ref.state.selectedUser.label+" has been successfully updated",
//                         messageType:1,
//                         messageBoxOpen:true
//                     })
//                 }
//                 else{
//                     dashboar_ref.setState({
//                         messageTitle:"Role Could Not Be Updated",
//                         messageBody:"The role for "+dashboar_ref.state.selectedUser.label+" could not be updated",
//                         messageType:0,
//                         messageBoxOpen:true
//                     })
//                 }
//             }
//             if(http.readyState === 4 && http.status === 401){
//                 logout()
//             }
//         }
//         http.onerror = function(){
//             dashboar_ref.setState({
//                 messageTitle:"Role Could Not Be Updated",
//                 messageBody:"The role for "+dashboar_ref.state.selectedUser.label+" could not be updated",
//                 messageType:0,
//                 messageBoxOpen:true
//             })
//         }
//         http.ontimeout = function(){
//             dashboar_ref.setState({
//                 messageTitle:"Role Could Not Be Updated",
//                 messageBody:"The role for "+dashboar_ref.state.selectedUser.label+" could not be updated",
//                 messageType:0,
//                 messageBoxOpen:true
//             })
//         }
//     }

//     render(){
//         if(this.state.section === 0){
//             return(
//                 <div>
//                 <Loader loading={true} fullPage={true} />
//             </div>
//             )
//         }
//         if(this.state.section === 1){
//             if(this.state.superuser === "true"){
//                 return(
//                     <div>
//                         <Modal isOpen={this.state.messageBoxOpen}>
//                             <ModalHeader>{this.state.messageTitle}</ModalHeader>
//                             <ModalBody>
//                                 <b>{this.state.messageBody}</b>
//                             </ModalBody>
//                             <ModalFooter>
//                             <Button color="primary" onClick={this.closeMessageBox}>Close</Button>
//                             </ModalFooter>
//                         </Modal>
//                         <Modal isOpen={this.state.editOragizationModalOpen}>
//                             <ModalHeader>Change Organization</ModalHeader>

//                             <ModalBody>
//                             <h6>Organization:</h6>
//                             <Select options={this.state.organizations} value={this.state.selectedOrganizations} onChange={this.HandleOrganizationSelect} isMulti={true}/>
//                             </ModalBody>
//                             <ModalFooter>
//                                 <Button color="primary" onClick={this.CloseOrgEditModal}>Close</Button>
//                             </ModalFooter>
//                         </Modal>
//                         <Modal isOpen={this.state.editBranchModalOpen}>
//                             <Loader loading={this.state.modalLoading} />
//                             <ModalHeader>
//                                 Change Branches
//                             </ModalHeader>
//                             <ModalBody>
//                             <h6>Organization:</h6>
//                             <SelectList options={this.state.organizations} selectedOption={this.state.branchAdminSelectedOrg} actionHandler={this.HandleBranchAdminOrgSelect}/>
//                             <h6 style={{marginTop:10}}>Branches:</h6>
//                             <Select options={this.state.branch_opts} value={this.state.selectedBranches} onChange={this.HandleBranchSelect} isMulti={true}/>
//                             </ModalBody>
//                             <ModalFooter>
//                                 <Button color="primary" onClick={this.CloseBranchEditModal}>Close</Button>
//                             </ModalFooter>
//                         </Modal>
//                         <div className="clearfix"  id="page-header">
//                                 <div>
//                                    <Header />
//                                    </div>
//                             </div>

//                             <div >
//                                 <SideBar isActive="roles"/>
//                             </div>
//                             <div id="page-content-wrapper" className="rm-transition">
//                             <div id="page-content">
//                             <Loader loading={this.state.loading} fullPage={true} />
//                             <div className="row">
//                                 <div className="col-md-4"></div>
//                                 <div className="col-md-4">
//                                     <h2 style={{textAlign:"center"}}>Manage Users</h2>
//                                 </div>
//                                 <div className="col-md-4"></div>
//                             </div>
//                             <div className="row">
//                                 <div className="col-md-2"></div>
//                                 <div className="col-md-8">
//                                 <h5>Select a User</h5>
//                                 <SelectList options={this.state.user_options} selectedOption={this.state.selectedUser} actionHandler={this.HandleUserSelect}/>

//                                 </div>

//                                 <div className="col-md-2"></div>
//                             </div>
//                             <ReactCSSTransitionGroup transitionName="example">
//                             <div hidden={this.state.userDeatilViewHidden}>

//                             <div className="row" style={{marginTop:30}}>
//                             <div className="col-md-2"></div>
//                             <div className="col-md-8">
//                                 <h3 style={{textAlign:"center"}}>User permissions</h3>
//                                 <input type="radio" name="permission" value="one" id="super" class="form-radio"  ></input><label className="my-label">Super User</label><br></br>
//                                 <input type="radio" name="permission" value="one" id="org" class="form-radio" onClick={this.HandleOrgEditClick}></input><label className="my-label">Organizational Admin</label><i hidden={this.state.orgEdit} class="fa fa-edit role-edit" onClick={this.HandleOrgEditClick}></i><br></br>
//                                 <input type="radio" name="permission" value="branch" id="branch" class="form-radio" onClick={this.HandleBranchRadioClick}></input><label className="my-label">Branch Admin</label><i hidden={this.state.branchEdit} id="branchEdit" class="fa fa-edit role-edit" onClick={this.HandleBranchRadioClick}></i><br></br>
//                                 <input type="radio" name="permission" value="branch" id="branchView" class="form-radio" onClick={this.HandleBranchViewRadioClick}></input><label className="my-label">Branch User</label><i hidden={this.state.branchViewEdit} id="branchViewEdit" class="fa fa-edit role-edit" onClick={this.HandleBranchViewRadioClick}></i><br></br>
//                                 <input type="radio" name="permission" value="revoke" id="revoked" class="form-radio" ></input><label className="my-label">User Blocked</label><br></br>
//                                 <button type="button" className="btn btn-block btn-primary" max-width='100%' onClick={this.updateRoles}>Update User permissions</button>
//                             </div>
//                             <div className="col-md-2"></div>
//                             </div>

//                             </div>
//                             </ReactCSSTransitionGroup>

//                             </div>
//                             </div>
//                     </div>
//                 )
//             }
//         }
//         if(this.state.organization_admin === "true"){
//             return(
//                 <div>
//                     <Modal isOpen={this.state.messageBoxOpen}>
//                         <ModalHeader>{this.state.messageTitle}</ModalHeader>
//                         <ModalBody>
//                             <b>{this.state.messageBody}</b>
//                         </ModalBody>
//                         <ModalFooter>
//                         <Button color="primary" onClick={this.closeMessageBox}>Close</Button>
//                         </ModalFooter>
//                     </Modal>
//                     <Modal isOpen={this.state.editBranchModalOpen}>
//                         <Loader loading={this.state.modalLoading} />
//                         <ModalHeader>
//                             Change Branches
//                         </ModalHeader>
//                         <ModalBody>
//                         <h6>Organization:</h6>
//                         <SelectList options={this.state.organizations} selectedOption={this.state.branchAdminSelectedOrg} actionHandler={this.HandleBranchAdminOrgSelect}/>
//                         <h6 style={{marginTop:10}}>Branches:</h6>
//                         <Select options={this.state.branch_opts} value={this.state.selectedBranches} onChange={this.HandleBranchSelect} isMulti={true}/>
//                         </ModalBody>
//                         <ModalFooter>
//                             <Button color="primary" onClick={this.CloseBranchEditModal}>Close</Button>
//                         </ModalFooter>
//                     </Modal>
//                     <div className="clearfix"  id="page-header">
//                             <div>
//                                <Header />
//                                </div>
//                         </div>

//                         <div >
//                             <SideBar isActive="roles"/>
//                         </div>
//                         <div id="page-content-wrapper" className="rm-transition">
//                         <div id="page-content">
//                         <Loader loading={this.state.loading} fullPage={true} />
//                         <div className="row">
//                             <div className="col-md-4"></div>
//                             <div className="col-md-4">
//                                 <h2 style={{textAlign:"center"}}>Manage Users</h2>
//                             </div>
//                             <div className="col-md-4"></div>
//                         </div>
//                         <div className="row">
//                             <div className="col-md-2"></div>
//                             <div className="col-md-8">
//                             <h5>Select a User</h5>
//                             <SelectList options={this.state.user_options} selectedOption={this.state.selectedUser} actionHandler={this.HandleUserSelect}/>

//                             </div>

//                             <div className="col-md-2"></div>
//                         </div>
//                         <ReactCSSTransitionGroup transitionName="example">
//                         <div hidden={this.state.userDeatilViewHidden}>

//                         <div className="row" style={{marginTop:30}}>
//                         <div className="col-md-2"></div>
//                         <div className="col-md-8">
//                             <h3 style={{textAlign:"center"}}>User permissions</h3>
//                             <input type="radio" name="permission" value="branch" id="branch" class="form-radio" onClick={this.HandleBranchRadioClick}></input><label className="my-label">Branch Admin</label><i hidden={this.state.branchEdit} id="branchEdit" class="fa fa-edit role-edit" onClick={this.HandleBranchRadioClick}></i><br></br>
//                             <input type="radio" name="permission" value="branch" id="branchView" class="form-radio" onClick={this.HandleBranchRadioClick}></input><label className="my-label">Branch View</label><i hidden={this.state.branchView} id="branchViewEdit" class="fa fa-edit role-edit" onClick={this.HandleBranchRadioClick}></i><br></br>
//                             <input type="radio" name="permission" value="branch" id="branchView" class="form-radio" onClick={this.HandleBranchViewRadioClick}></input><label className="my-label">Branch User</label><i hidden={this.state.branchViewEdit} id="branchViewEdit" class="fa fa-edit role-edit" onClick={this.HandleBranchViewRadioClick}></i><br></br>
//                             <input type="radio" name="permission" value="revoke" id="revoked" class="form-radio" ></input><label className="my-label">User Blocked</label><br></br>
//                             <button type="button" className="btn btn-block btn-primary" max-width='100%' onClick={this.updateRoles}>Update User permissions</button>
//                         </div>
//                         <div className="col-md-2"></div>
//                         </div>

//                         </div>
//                         </ReactCSSTransitionGroup>

//                         </div>
//                         </div>
//                 </div>
//             )
//         }
//     }
// }

// export default RoleManagement;

import React from 'react'
import { Loader } from 'react-overlay-loader'
import Cookies from 'universal-cookie'
import '../CSS/assets-minified/all-demo.css'
import '../CSS/assets-minified/css/bootstrap.min.css'
import Header from '../components/dashboardSubComponents/header'
import SideBar from '../components/dashboardSubComponents/sideBarNav'
import { logout, url } from '../components/helper'
// import ResponseTable from './responseListSubComponenets/responseTable'
// import MultiSelectList from './roleManagementSubComponents/mutiSelectList'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import Select from 'react-select'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import SelectList from '../components/createQuestionSubComponents/dropdownSelect'

const RoleManagement = () => {
    const [section, setSection] = React.useState(1)
    const [orgEdit, setOrgEdit] = React.useState(true)
    const [branchEdit, setBranchEdit] = React.useState(true)
    const [branchView, setbranchView] = React.useState(false)
    const [branchViewEdit, setBranchViewEdit] = React.useState(true)
    const [userDetailViewHidden, setUserDetailViewHidden] = React.useState(true)
    const [superuser, setSuperuser] = React.useState(false)
    const [organizationAdmin, setOrganizationAdmin] = React.useState(false)
    const [editOrganizationModalOpen, setEditOrganizationModalOpen] =
        React.useState(false)
    const [editBranchModalOpen, setEditBranchModalOpen] = React.useState(false)
    const [allUsers, setAllUsers] = React.useState([])
    const [organizations, setOrganizations] = React.useState([])
    const [selectedOrganizations, setSelectedOrganizations] = React.useState([])
    const [branches, setBranches] = React.useState([])
    const [branchOpts, setBranchOpts] = React.useState([])
    const [branchAdminSelectedOrg, setBranchAdminSelectedOrg] =
        React.useState(null)
    const [selectedBranches, setSelectedBranches] = React.useState([])
    const [userOptions, setUserOptions] = React.useState([])
    const [selectedUser, setSelectedUser] = React.useState(null)
    const [modalLoading, setModalLoading] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [messageBoxOpen, setMessageBoxOpen] = React.useState(false)
    const [messageTitle, setMessageTitle] = React.useState('')
    const [messageBody, setMessageBody] = React.useState('')
    const [messageType, setMessageType] = React.useState(0)

    //Precheck the credentials prior to rendering
    const credentialCheck = () => {
        const cookies = new Cookies()

        const token = cookies.get('token')
        if (!token) {
            window.location = '/login'
        }

        if (
            cookies.get('branch-admin') === 'true' ||
            cookies.get('branch-user') === 'true'
        ) {
            window.location = '/dashboard'
        }
        const superuser = cookies.get('superuser')
        const orgAdmin = cookies.get('organization-admin')
        // alert(`Super ${superuser}, orgAdmin ${orgAdmin}`)
        setSuperuser(superuser)
        setOrganizationAdmin(orgAdmin)
    }

    //Get current user role
    const getRoles = async () => {
        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')
        const options = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-type': 'application/x-www-form-urlencoded',
            },
        }

        try {
            const res = await fetch(
                `${url}/api/user/role?user_id=${userId}`,
                options
            )
            const data = await res.json()

            switch (data.status) {
                case 200:
                    let user_opts = []
                    let org_opts = []

                    data.users.forEach((detail) => {
                        let user = {
                            value: detail.user_id,
                            label: `${detail.first_name} ${detail.last_name} (${detail.username})`,
                            id: detail.user_id,
                        }
                        user_opts.push(user)
                    })

                    data.organisations.forEach((detail) => {
                        let org = {
                            value: detail.org_id,
                            label: detail.org_name,
                            id: detail.org_id,
                        }
                        org_opts.push(org)
                    })
                    setUserOptions(user_opts)
                    setAllUsers(data.users)
                    setOrganizations(org_opts)
                    break
                default:
                    console.error('Invalid data:', data)
                    break
            }
        } catch (err) {
            console.error('Error', err)
        }
    }

    React.useEffect(() => {
        credentialCheck()
        getRoles()
    }, [])

    const handleUserSelect = (user) => {
        allUsers.forEach((cred) => {
            if (user.id === cred.user_id) {
                //Super Admin Check
                if (cred.is_super_admin) {
                    document.getElementById('super').checked = true
                    setBranchEdit(true)
                    setOrgEdit(true)
                }

                //Organisation Check
                if (cred.is_org_admin && cred.user_orgs.length !== 0) {
                    document.getElementById('org').checked = true
                    setOrgEdit(false)
                    setBranchEdit(true)
                }

                //Branch Admin Check
                if (cred.is_branch_admin && cred.user_branches.length !== 0) {
                    document.getElementById('branch').checked = true
                    fetchOrgBranches(cred.user_branches[0].org_id)
                    setBranchEdit(false)
                    setOrgEdit(true)
                    setLoading(true)
                }
                //There was a "fix later" comment here
                if (cred.is_branch_user && cred.user_branches.length !== 0) {
                    document.getElementById('branchView').checked = true
                    fetchOrgBranches(cred.user_branches[0].org_id)
                    setBranchViewEdit(false)
                    setOrgEdit(false)
                    setLoading(true)
                }
                if (cred.is_revoked) {
                    document.getElementById('revoked').checked = true
                    setBranchEdit(true)
                    setOrgEdit(true)
                }
            }
            setSelectedUser(user)
            setUserDetailViewHidden(false)
            setSelectedOrganizations([])
            setBranchAdminSelectedOrg(null)
            setSelectedBranches([])
        })
    }

    const fetchOrgBranches = async (org_id) => {
        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-type': 'application/x-www-form-urlencoded',
            },
        }

        try {
            const res = await fetch(
                `${url}/api/questions/wizard/branch?user_id=${userId}&org_id=${org_id}`,
                options
            )
            const data = await res.json()

            switch (data.status) {
                case 200:
                    let branches = []
                    data.branches.forEach((branch) => {
                        const detail = {
                            value: branch.branch_id,
                            label: branch.branch_name,
                            id: branch.branch_id,
                        }
                        branches.push(detail)
                    })
                    setBranchOpts(branches)
                    setBranches(data.branches)
                    setModalLoading(false)
                    setLoading(false)
                    break
                default:
                    console.error('Invalid data:', data)
                    break
            }
        } catch (err) {
            console.error('Error:', err)
        }
    }

    const closeOrgEditModal = () => {
        setEditOrganizationModalOpen(false)
    }

    const closeMessageBox = () => {
        if (messageType === 1) {
            setMessageBoxOpen(false)
            window.location = '/role-management/'
        } else {
            setMessageBoxOpen(false)
        }
    }

    const handleOrgRadioClick = () => {
        if (selectedOrganizations.length === 0) {
            const target = selectedUser
            const isChecked = document.getElementById('org').checked
            if (isChecked) {
                let targetOrgs = []
                let tempSelectedOpts = []
                allUsers.forEach((user) => {
                    if (user.user_id === target.id) {
                        targetOrgs = user.user_orgs
                    }
                })
                targetOrgs.forEach((orgs) => {
                    tempSelectedOpts.push({
                        value: orgs.org_id,
                        label: orgs.org_name,
                        id: orgs.org_id,
                    })
                })
                setEditOrganizationModalOpen(true)
                setSelectedOrganizations(tempSelectedOpts)
            }
        }
    }

    const handleOrgEditClick = () => {
        document.getElementById('org').checked = true
        if (selectedOrganizations.length === 0) {
            const target = selectedUser
            let targetOrgs = []
            let tempSelectedOpts = []
            allUsers.forEach((user) => {
                if (user.user_id === target.id) {
                    targetOrgs = user.user_orgs
                }
            })
            targetOrgs.forEach((orgs) => {
                tempSelectedOpts.push({
                    value: orgs.org_id,
                    label: orgs.org_name,
                    id: orgs.org_id,
                })
            })
            setEditOrganizationModalOpen(true)
            setSelectedOrganizations(tempSelectedOpts)
        } else {
            setEditOrganizationModalOpen(true)
        }
    }

    const handleOrganizationSelect = (orgs) => {
        setSelectedOrganizations(orgs)
    }

    const closeBranchEditModal = () => {
        setEditBranchModalOpen(false)
    }
    const handleBranchRadioClick = () => {
        document.getElementById('branch').checked = true
        let targetUser = null
        let targetOrg = null
        let targetBranches = []
        allUsers.forEach((user) => {
            if (selectedUser.id === user.user_id) {
                targetUser = user
            }
        })
        if (targetUser.user_branches.length !== 0) {
            if (!branchAdminSelectedOrg) {
                organizations.forEach((org) => {
                    if (org.id === targetUser.user_branches[0].org_id) {
                        targetOrg = org
                    }
                })
            } else {
                targetOrg = branchAdminSelectedOrg
            }
            targetUser.user_branches.forEach((userBranch) => {
                branches.forEach((branch) => {
                    if (branch.branch_id === userBranch.branch_id) {
                        targetBranches.push({
                            value: userBranch.branch_id,
                            label: userBranch.branch_name,
                            id: userBranch.branch_id,
                        })
                    }
                })
            })

            setBranchAdminSelectedOrg(targetOrg)
            setSelectedBranches(targetBranches)
        }
        setEditBranchModalOpen(true)
    }

    const handleBranchViewRadioClick = () => {
        document.getElementById('branchView').checked = true
        let targetUser = null
        let targetOrg = null
        let targetBranches = []
        allUsers.forEach((user) => {
            if (selectedUser.id === user.user_id) {
                targetUser = user
            }
        })
        if (targetUser.user_branches.length !== 0) {
            if (!branchAdminSelectedOrg) {
                organizations.forEach((org) => {
                    if (org.id === targetUser.user_branches[0].org_id) {
                        targetOrg = org
                    }
                })
            } else {
                targetOrg = branchAdminSelectedOrg
            }
            targetUser.user_branches.forEach((userBranch) => {
                branches.forEach((branch) => {
                    if (branch.branch_id === userBranch.branch_id) {
                        targetBranches.push({
                            value: userBranch.branch_id,
                            label: userBranch.branch_name,
                            id: userBranch.branch_id,
                        })
                    }
                })
            })

            setBranchAdminSelectedOrg(targetOrg)
            setSelectedBranches(targetBranches)
        }
        setEditBranchModalOpen(true)
    }
    const handleBranchAdminOrgSelect = (org) => {
        let targetUser = null
        let targetBranches = []

        allUsers.forEach((user) => {
            if (selectedUser.id === user.user_id) {
                targetUser = user
            }
        })
        if (
            targetUser.is_branch_admin &&
            targetUser.user_branches[0].org_id === org.id
        ) {
            fetchOrgBranches(org.id)
            targetUser.user_branches.forEach((userBranch) => {
                targetBranches.push({
                    value: userBranch.branch_id,
                    label: userBranch.branch_name,
                    id: userBranch.branch_id,
                })
            })
            setBranchAdminSelectedOrg(org)
            setSelectedBranches(targetBranches)
            setModalLoading(true)
        } else {
            setBranchAdminSelectedOrg(org)
            setBranchOpts([])
            setBranches([])
            setSelectedBranches([])
            setModalLoading(true)
            fetchOrgBranches(org.id)
        }
    }
    const handleBranchSelect = (branch) => {
        setSelectedBranches(branch)
    }

    //Could split
    const updateRoles = async () => {
        let argList = `&u_id=${selectedUser.id}`
        let superUser = false
        let org = null

        //Has to be a better way
        if (superuser === 'true') {
            superUser = document.getElementById('super').checked
            org = document.getElementById('org').checked
        }

        const branch = document.getElementById('branch').checked
        const branchView = document.getElementById('branchView').checked
        const revoked = document.getElementById('revoked').checked

        if (org && selectedOrganizations.length === 0) {
            setMessageTitle('No Organization Selected')
            setMessageBody(
                'You have checked Organization Admin Option. Please also select at least one organization'
            )
            setMessageBoxOpen(true)
            return
        }

        if (
            branch &&
            (!branchAdminSelectedOrg || selectedBranches.length === 0)
        ) {
            setMessageTitle('No Organization/Branch Selected')
            setMessageBody(
                'You have checked Branch Admin Option. Please also select atleast one organization and branch'
            )
            setMessageBoxOpen(true)
            return
        }

        if (org) {
            let orgs = ''
            selectedOrganizations.forEach((selectedOrg) => {
                orgs = `${orgs},${selectedOrg.id}`
            })
            orgs = orgs.substring(1)
            argList = `${argList}&is_org=True&orgs=${orgs}`
        }

        if (branch) {
            let branches = ''
            selectedBranches.forEach((selectedBranch) => {
                branches = `${branches},${selectedBranch.id}`
            })
            argList = `${argList}&is_branch=True&branches=${branches.substring(
                1
            )}`
        }
        if (branchView) {
            let viewBranches = ''
            selectedBranches.forEach((selectedBranch) => {
                viewBranches = `${viewBranches},${selectedBranch.id}`
            })
            argList = `${argList}&is_branch_user=True&branches=${viewBranches.substring(
                1
            )}`
        }
        if (superUser) {
            argList = `${argList}&is_super=True`
        }
        if (revoked) {
            argList = `${argList}&is_revoked=True`
        }

        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-type': 'application/x-www-form-urlencoded',
            },
            body: argList,
        }

        try {
            const res = await fetch(
                `${url}/api/user/role?user_id=${userId}`,
                options
            )
            const data = await res.json()

            switch (data.status) {
                case 200:
                    setMessageTitle('Role Updated')
                    setMessageBody(
                        `The role for ${selectedUser.label} has been successfully updated`
                    )
                    setMessageType(1)
                    setMessageBoxOpen(true)
                    break
                case 401:
                    logout()
                    break
                default:
                    setMessageTitle('Role Could Not Be Updated')
                    setMessageBody(
                        `The role for ${selectedUser.label} could not be updated`
                    )
                    setMessageType(0)
                    setMessageBoxOpen(true)
                    break
            }
        } catch (err) {
            setMessageTitle('Role Could Not Be Updated')
            setMessageBody(
                `The role for ${selectedUser.label} could not be updated`
            )
            setMessageType(0)
            setMessageBoxOpen(true)
        }
    }

    return (
        <div>
            {section === 0 ? (
                <div>
                    <Loader loading={true} fullPage={true} />
                </div>
            ) : (
                <div></div>
            )}
            {section === 1 && superuser === 'true' ? (
                <div>
                    <Modal isOpen={messageBoxOpen}>
                        <ModalHeader>{messageTitle}</ModalHeader>
                        <ModalBody>
                            <b>{messageBody}</b>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={closeMessageBox}>
                                Close
                            </Button>
                        </ModalFooter>
                    </Modal>
                    <Modal isOpen={editOrganizationModalOpen}>
                        <ModalHeader>Change Organization</ModalHeader>

                        <ModalBody>
                            <h6>Organization:</h6>
                            <Select
                                options={organizations}
                                value={selectedOrganizations}
                                onChange={handleOrganizationSelect}
                                isMulti={true}
                            />
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={closeOrgEditModal}>
                                Close
                            </Button>
                        </ModalFooter>
                    </Modal>
                    <Modal isOpen={editBranchModalOpen}>
                        <Loader loading={modalLoading} />
                        <ModalHeader>Change Branches</ModalHeader>
                        <ModalBody>
                            <h6>Organization:</h6>
                            <SelectList
                                options={organizations}
                                selectedOption={branchAdminSelectedOrg}
                                actionHandler={handleBranchAdminOrgSelect}
                            />
                            <h6 style={{ marginTop: 10 }}>Branches:</h6>
                            <Select
                                options={branchOpts}
                                value={selectedBranches}
                                onChange={handleBranchSelect}
                                isMulti={true}
                            />
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="primary"
                                onClick={closeBranchEditModal}
                            >
                                Close
                            </Button>
                        </ModalFooter>
                        Admin
                    </Modal>
                    <div className="clearfix" id="page-header">
                        <div>
                            <Header />
                        </div>
                    </div>

                    <div>
                        <SideBar isActive="roles" />
                    </div>
                    <div id="page-content-wrapper" className="rm-transition">
                        <div id="page-content">
                            <Loader loading={loading} fullPage={true} />
                            <div className="row">
                                <div className="col-md-4"></div>
                                <div className="col-md-4">
                                    <h2 style={{ textAlign: 'center' }}>
                                        Manage Users
                                    </h2>
                                </div>
                                <div className="col-md-4"></div>
                            </div>
                            <div className="row">
                                <div className="col-md-2"></div>
                                <div className="col-md-8">
                                    <h5>Select a User</h5>
                                    <SelectList
                                        options={userOptions}
                                        selectedOption={selectedUser}
                                        actionHandler={handleUserSelect}
                                    />
                                </div>

                                <div className="col-md-2"></div>
                            </div>
                            <ReactCSSTransitionGroup transitionName="example">
                                <div hidden={userDetailViewHidden}>
                                    <div
                                        className="row"
                                        style={{ marginTop: 30 }}
                                    >
                                        <div className="col-md-2"></div>
                                        <div className="col-md-8">
                                            <h3 style={{ textAlign: 'center' }}>
                                                User permissions
                                            </h3>
                                            <input
                                                type="radio"
                                                name="permission"
                                                value="one"
                                                id="super"
                                                class="form-radio"
                                            ></input>
                                            <label className="my-label">
                                                Super User
                                            </label>
                                            <br></br>
                                            <input
                                                type="radio"
                                                name="permission"
                                                value="one"
                                                id="org"
                                                class="form-radio"
                                                onClick={handleOrgEditClick}
                                            ></input>
                                            <label className="my-label">
                                                Organizational Admin
                                            </label>
                                            <i
                                                hidden={orgEdit}
                                                class="fa fa-edit role-edit"
                                                onClick={handleOrgEditClick}
                                            ></i>
                                            <br></br>
                                            <input
                                                type="radio"
                                                name="permission"
                                                value="branch"
                                                id="branch"
                                                class="form-radio"
                                                onClick={handleBranchRadioClick}
                                            ></input>
                                            <label className="my-label">
                                                Branch Admin
                                            </label>
                                            <i
                                                hidden={branchEdit}
                                                id="branchEdit"
                                                class="fa fa-edit role-edit"
                                                onClick={handleBranchRadioClick}
                                            ></i>
                                            <br></br>
                                            <input
                                                type="radio"
                                                name="permission"
                                                value="branch"
                                                id="branchView"
                                                class="form-radio"
                                                onClick={
                                                    handleBranchViewRadioClick
                                                }
                                            ></input>
                                            <label className="my-label">
                                                Branch User
                                            </label>
                                            <i
                                                hidden={branchViewEdit}
                                                id="branchViewEdit"
                                                class="fa fa-edit role-edit"
                                                onClick={
                                                    handleBranchViewRadioClick
                                                }
                                            ></i>
                                            <br></br>
                                            <input
                                                type="radio"
                                                name="permission"
                                                value="revoke"
                                                id="revoked"
                                                class="form-radio"
                                            ></input>
                                            <label className="my-label">
                                                User Blocked
                                            </label>
                                            <br></br>
                                            <button
                                                type="button"
                                                className="btn btn-block btn-primary"
                                                max-width="100%"
                                                onClick={updateRoles}
                                            >
                                                Update User permissions
                                            </button>
                                        </div>
                                        <div className="col-md-2"></div>
                                    </div>
                                </div>
                            </ReactCSSTransitionGroup>
                        </div>
                    </div>
                </div>
            ) : (
                <div></div>
            )}
            {section === 1 && organizationAdmin === 'true' ? (
                <div>
                    <Modal isOpen={messageBoxOpen}>
                        <ModalHeader>{messageTitle}</ModalHeader>
                        <ModalBody>
                            <b>{messageBody}</b>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={closeMessageBox}>
                                Close
                            </Button>
                        </ModalFooter>
                    </Modal>
                    <Modal isOpen={editBranchModalOpen}>
                        <Loader loading={modalLoading} />
                        <ModalHeader>Change Branches</ModalHeader>
                        <ModalBody>
                            <h6>Organization:</h6>
                            <SelectList
                                options={organizations}
                                selectedOption={branchAdminSelectedOrg}
                                actionHandler={handleBranchAdminOrgSelect}
                            />
                            <h6 style={{ marginTop: 10 }}>Branches:</h6>
                            <Select
                                options={branchOpts}
                                value={selectedBranches}
                                onChange={handleBranchSelect}
                                isMulti={true}
                            />
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="primary"
                                onClick={closeBranchEditModal}
                            >
                                Close
                            </Button>
                        </ModalFooter>
                    </Modal>
                    <div className="clearfix" id="page-header">
                        <div>
                            <Header />
                        </div>
                    </div>

                    <div>
                        <SideBar isActive="roles" />
                    </div>
                    <div id="page-content-wrapper" className="rm-transition">
                        <div id="page-content">
                            <Loader loading={loading} fullPage={true} />
                            <div className="row">
                                <div className="col-md-4"></div>
                                <div className="col-md-4">
                                    <h2 style={{ textAlign: 'center' }}>
                                        Manage Users
                                    </h2>
                                </div>
                                <div className="col-md-4"></div>
                            </div>
                            <div className="row">
                                <div className="col-md-2"></div>
                                <div className="col-md-8">
                                    <h5>Select a User</h5>
                                    <SelectList
                                        options={userOptions}
                                        selectedOption={selectedUser}
                                        actionHandler={handleUserSelect}
                                    />
                                </div>

                                <div className="col-md-2"></div>
                            </div>
                            <ReactCSSTransitionGroup transitionName="example">
                                <div hidden={userDetailViewHidden}>
                                    <div
                                        className="row"
                                        style={{ marginTop: 30 }}
                                    >
                                        <div className="col-md-2"></div>
                                        <div className="col-md-8">
                                            <h3 style={{ textAlign: 'center' }}>
                                                User permissions
                                            </h3>
                                            <input
                                                type="radio"
                                                name="permission"
                                                value="branch"
                                                id="branch"
                                                class="form-radio"
                                                onClick={handleBranchRadioClick}
                                            ></input>
                                            <label className="my-label">
                                                Branch Admin
                                            </label>
                                            <i
                                                hidden={branchEdit}
                                                id="branchEdit"
                                                class="fa fa-edit role-edit"
                                                onClick={handleBranchRadioClick}
                                            ></i>
                                            <br></br>
                                            <input
                                                type="radio"
                                                name="permission"
                                                value="branch"
                                                id="branchView"
                                                class="form-radio"
                                                onClick={handleBranchRadioClick}
                                            ></input>
                                            <label className="my-label">
                                                Branch View
                                            </label>
                                            <i
                                                hidden={branchView}
                                                id="branchViewEdit"
                                                class="fa fa-edit role-edit"
                                                onClick={handleBranchRadioClick}
                                            ></i>
                                            <br></br>
                                            <input
                                                type="radio"
                                                name="permission"
                                                value="branch"
                                                id="branchView"
                                                class="form-radio"
                                                onClick={
                                                    handleBranchViewRadioClick
                                                }
                                            ></input>
                                            <label className="my-label">
                                                Branch User
                                            </label>
                                            <i
                                                hidden={branchViewEdit}
                                                id="branchViewEdit"
                                                class="fa fa-edit role-edit"
                                                onClick={
                                                    handleBranchViewRadioClick
                                                }
                                            ></i>
                                            <br></br>
                                            <input
                                                type="radio"
                                                name="permission"
                                                value="revoke"
                                                id="revoked"
                                                class="form-radio"
                                            ></input>
                                            <label className="my-label">
                                                User Blocked
                                            </label>
                                            <br></br>
                                            <button
                                                type="button"
                                                className="btn btn-block btn-primary"
                                                max-width="100%"
                                                onClick={updateRoles}
                                            >
                                                Update User permissions
                                            </button>
                                        </div>
                                        <div className="col-md-2"></div>
                                    </div>
                                </div>
                            </ReactCSSTransitionGroup>
                        </div>
                    </div>
                </div>
            ) : (
                <div></div>
            )}
        </div>
    )
}

export default RoleManagement

/**
 * Notes
 * - handleBranchViewRadioClick and handleBranchRadioClick are near identical, handleBranchAdminOrgSelect similar
 * - What is with the substring?
 * - Backend might need rejigging to make this page less terrible. They crammed everything in the url
 * - Everything on this page seems like it was done the worst way possible x_X
 * - Could split updateRoles into a arg constructor and then the fetch
 */



// WEBPACK FOOTER //
// src/Routes/RoleManagement.js